import moment from 'moment';

export default (dates, inputFormat = 'MM', outputFormat = 'MMMM') => {
  return dates.map((date) => {
    return moment(date, inputFormat).format(outputFormat);
  });
}
